import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Asset, AssetService} from '@app/asset';
import {deserialize} from '@app/serializable';
import {StateService} from '@app/state/state.service';
import {Observable, of} from 'rxjs';
import {catchError, filter, map} from 'rxjs/operators';

export class AssetLink {
    id: string;
    stream: any;
    assets: Asset[];
    url: string;
}

@Injectable({
    providedIn: 'root',
})
export class AssetLinkService {
    constructor(
        private stateService: StateService,
        private assetService: AssetService,
        private matSnackBar: MatSnackBar,
        private http: HttpClient,
    ) {
        this.stateService.state
            .pipe(filter((state) => state.assetLink !== null))
            .subscribe((state) => {
                this.get(state.assetLink);
            });
    }

    get(assetLinkId: string) {
        const url = `/api/assetlink/${assetLinkId}/`;
        this.http
            .get<AssetLink>(url)
            .pipe(
                catchError((err) => {
                    this.matSnackBar.open(err.error.detail, 'ok', {
                        verticalPosition: 'top',
                        panelClass: ['error-snackbar'],
                    });
                    return of(null);
                }),
            )
            .subscribe((assetLink) => {
                if (assetLink !== null) {
                    // this.stateService.patchState('streamId', assetLink.stream.id);
                    this.assetService.setFilteredAssets(assetLink.assets);
                }
            });
    }

    create(assetIds: string[], streamId: string): Observable<AssetLink> {
        const url = '/api/assetlink/';
        const options = {
            asset_ids: assetIds,
            stream: streamId,
            withCredentials: true,
        };

        return this.http.post(url, options).pipe(
            map((result) => {
                const assetLink = deserialize(AssetLink, result);
                assetLink.url = new URL(`/l/${assetLink.id}`, window.location.toString()).href;

                return assetLink;
            }),
        );
    }
}
